import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statBranchMonthReportLocaleModule: LocaleModule = {
  name: "statBranchMonthReport",
  messages: { en: en, it: it },
};
